



































































































































































































import { Component, Vue } from "vue-property-decorator";
import { getQuestionList as fetchQuestionList, QuestionForm } from "@/serve/question/question";
import { getQuestionTypeAllList, QuestionTypeForm } from "@/serve/question/questionType";
import {
  deleteQuestionRecord,
  downloadQuestionRecordPdf,
  exportQuestionRecordDetailExcel,
  exportQuestionRecordExcel,
  exportQuestionRecordPersonDetailExcel,
  getQuestionRecordDetail,
  getQuestionRecordList,
  getQuestionRecordStatistics,
  QuestionRecordQuery,
  viewQuestionRecordPdf
} from "@/serve/question/questionRecord";

@Component({
  name: "RecordPage"
})
export default class RecordPage extends Vue {
  public form: QuestionRecordQuery = this.emptyForm();
  public submitRange: string[] = [];
  public typeList: QuestionTypeForm[] = [];
  public questionList: QuestionForm[] = [];
  public tableData: any[] = [];
  public total = 0;
  public loading = false;
  public statistics: any = {};
  public detailDialog = false;
  public detailData: any = null;

  public created() {
    this.getTypeList();
    this.loadQuestionList();
    this.getTableData();
  }

  public get detailItems() {
    const items = ((this.detailData && this.detailData.items) || []).slice();
    return items.sort((left: any, right: any) => {
      const leftGroupSort = left.groupSort === null || left.groupSort === undefined ? Number.MAX_SAFE_INTEGER : Number(left.groupSort);
      const rightGroupSort = right.groupSort === null || right.groupSort === undefined ? Number.MAX_SAFE_INTEGER : Number(right.groupSort);
      if (leftGroupSort !== rightGroupSort) {
        return leftGroupSort - rightGroupSort;
      }
      const leftGroupId = left.groupId === null || left.groupId === undefined ? Number.MAX_SAFE_INTEGER : Number(left.groupId);
      const rightGroupId = right.groupId === null || right.groupId === undefined ? Number.MAX_SAFE_INTEGER : Number(right.groupId);
      if (leftGroupId !== rightGroupId) {
        return leftGroupId - rightGroupId;
      }
      const leftSort = left.sort === null || left.sort === undefined ? Number.MAX_SAFE_INTEGER : Number(left.sort);
      const rightSort = right.sort === null || right.sort === undefined ? Number.MAX_SAFE_INTEGER : Number(right.sort);
      if (leftSort !== rightSort) {
        return leftSort - rightSort;
      }
      return Number(left.id || 0) - Number(right.id || 0);
    });
  }

  public get hasDetailGroup() {
    return this.detailItems.some((item: any) => !!item.groupName);
  }

  public get detailResults() {
    const results = ((this.detailData && this.detailData.results) || []).slice();
    if (!this.hasDetailGroup) {
      return results;
    }
    const resultMap: any = {};
    results.forEach((item: any) => {
      const key = this.detailGroupKey(item);
      if (key && !resultMap[key]) {
        resultMap[key] = item;
      }
    });
    const groupRows: any[] = [];
    const groupMap: any = {};
    this.detailItems.forEach((item: any) => {
      const key = this.detailGroupKey(item);
      if (!key || groupMap[key]) {
        return;
      }
      groupMap[key] = true;
      const result = resultMap[key] || {};
      groupRows.push({
        groupId: item.groupId,
        groupName: item.groupName,
        groupSort: item.groupSort,
        score: result.score === null || result.score === undefined ? "" : result.score,
        resultName: result.resultName || "",
        resultDesc: result.resultDesc || "",
        suggestion: result.suggestion || ""
      });
    });
    return groupRows;
  }

  private emptyForm(): QuestionRecordQuery {
    return {
      current: 1,
      size: 10,
      questionId: null,
      questionName: "",
      typeId: null,
      checkerName: "",
      checkerGender: "",
      ageStart: null,
      ageEnd: null,
      checkerPhone: "",
      checkerIdCard: "",
      status: null,
      submitStartTime: "",
      submitEndTime: ""
    };
  }

  public async getTypeList() {
    const res = await getQuestionTypeAllList();
    if (res.success) {
      this.typeList = res.data || [];
    }
  }

  public async loadQuestionList() {
    const res = await fetchQuestionList({ current: 1, size: 500 });
    if (res.success) {
      this.questionList = (res.data && res.data.records) || [];
    }
  }

  private buildQuery() {
    const data = { ...this.form };
    data.submitStartTime = this.submitRange && this.submitRange.length ? this.submitRange[0] : "";
    data.submitEndTime = this.submitRange && this.submitRange.length ? this.submitRange[1] : "";
    return (this as any).$changNull(data);
  }

  public async getTableData() {
    this.loading = true;
    try {
      const data = this.buildQuery();
      const [listRes, statRes] = await Promise.all([
        getQuestionRecordList(data),
        getQuestionRecordStatistics(data)
      ]);
      if (listRes.success) {
        this.tableData = listRes.data.records || [];
        this.total = listRes.data.total || 0;
      }
      if (statRes.success) {
        this.statistics = statRes.data || {};
      }
    } finally {
      this.loading = false;
    }
  }

  public search() {
    this.form.current = 1;
    this.getTableData();
  }

  public resetForm() {
    this.form = this.emptyForm();
    this.submitRange = [];
    this.getTableData();
  }

  public async openDetail(row: any) {
    const res = await getQuestionRecordDetail(row.id);
    if (res.success) {
      this.detailData = res.data;
      this.detailDialog = true;
    }
  }

  public async exportMain() {
    const blob = await exportQuestionRecordExcel(this.buildQuery());
    this.downloadBlob(blob, "问卷主记录.xlsx");
  }

  public async exportDetail() {
    const blob = await exportQuestionRecordDetailExcel(this.buildQuery());
    this.downloadBlob(blob, "问卷记录按题明细.xlsx");
  }

  public async exportPersonDetail() {
    if (!this.form.questionId) {
      this.$message.warning("请先选择问卷名称");
      return;
    }
    const blob = await exportQuestionRecordPersonDetailExcel(this.buildQuery());
    this.downloadBlob(blob, "问卷记录按人明细.xlsx");
  }

  public async viewPdf(row: any) {
    const blob = await viewQuestionRecordPdf(row.id);
    if (await this.showBlobErrorIfNeeded(blob)) {
      return;
    }
    const url = URL.createObjectURL(blob);
    window.open(url);
  }

  public async downloadPdf(row: any) {
    const blob = await downloadQuestionRecordPdf(row.id);
    if (await this.showBlobErrorIfNeeded(blob)) {
      return;
    }
    this.downloadBlob(blob, `${row.questionName || "问卷记录"}-${row.id}.pdf`);
  }

  public canDeleteRecord(row: any) {
    return row && String(row.submitSource || "").trim() === "manage_test";
  }

  public deleteRecordRow(row: any) {
    (this as any).$messageBox.confirm("确定删除该后台测试记录吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      const res = await deleteQuestionRecord(row.id);
      if (res.success) {
        this.$message.success("删除成功");
        this.getTableData();
      } else {
        this.showApiMessage(res, "删除失败");
      }
    }).catch(() => undefined);
  }

  private async showBlobErrorIfNeeded(file: any): Promise<boolean> {
    if (file && file.success === false) {
      this.showApiMessage(file, "操作失败");
      return true;
    }
    if (!(file instanceof Blob)) {
      return false;
    }

    const type = file.type || "";
    if (type.indexOf("pdf") > -1 || type.indexOf("octet-stream") > -1) {
      return false;
    }
    if (type && type.indexOf("json") === -1 && type.indexOf("text") === -1) {
      return false;
    }

    try {
      const text = await this.readBlobAsText(file);
      const content = text.trim();
      if (!content || content.charAt(0) !== "{") {
        return false;
      }
      const data = JSON.parse(content);
      if (data && data.success === false) {
        this.showApiMessage(data, "操作失败");
        return true;
      }
    } catch {
      return false;
    }
    return false;
  }

  private showApiMessage(res: any, fallback: string, type: "error" | "warning" = "error") {
    if (res && res.__messageShown) {
      return;
    }
    this.$message[type]((res && res.msg) || fallback);
  }

  private readBlobAsText(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => reject(reader.error);
      reader.readAsText(blob, "utf-8");
    });
  }

  private downloadBlob(blob: Blob, filename: string) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  }

  public answerText(row: any) {
    const selected = (row.options || [])
      .filter((option: any) => option.selectedFlag === 1)
      .map((option: any) => option.optionInput ? `${option.optionLabel}(${option.optionInput})` : option.optionLabel)
      .join("、");
    return selected || row.answerText || "";
  }

  public detailSpanMethod({ rowIndex, columnIndex }: any) {
    if (!this.hasDetailGroup || columnIndex !== 1) {
      return;
    }
    const items = this.detailItems;
    const current = items[rowIndex];
    if (!current || !current.groupName) {
      return [1, 1];
    }
    const previous = items[rowIndex - 1];
    if (this.isSameDetailGroup(previous, current)) {
      return [0, 0];
    }
    let rowspan = 1;
    for (let index = rowIndex + 1; index < items.length; index++) {
      if (!this.isSameDetailGroup(current, items[index])) {
        break;
      }
      rowspan++;
    }
    return [rowspan, 1];
  }

  private isSameDetailGroup(left: any, right: any) {
    if (!left || !right || !left.groupName || !right.groupName) {
      return false;
    }
    if (left.groupId !== null && left.groupId !== undefined && right.groupId !== null && right.groupId !== undefined) {
      return String(left.groupId) === String(right.groupId);
    }
    return left.groupName === right.groupName;
  }

  private detailGroupKey(row: any) {
    if (!row) {
      return "";
    }
    if (row.groupId !== null && row.groupId !== undefined) {
      return `id:${row.groupId}`;
    }
    if (!row.groupName) {
      return "";
    }
    return `name:${row.groupName}`;
  }

  public statusLabel(status: number) {
    if (status === 1) {
      return "已提交";
    }
    if (status === 0) {
      return "未提交";
    }
    return status === null || status === undefined ? "" : String(status);
  }

  public handleSizeChange(size: number) {
    this.form.size = size;
    this.form.current = 1;
    this.getTableData();
  }

  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getTableData();
  }
}
